import React from 'react';
import { BrowserRouter, StaticRouter, Route, Switch } from 'react-router-dom';

import LazyBrowsePageWithStore from './LazyBrowsePageWithStore';
import LazyFeedPageWithStore from './LazyFeedPageWithStore';
import LazySearchPageWithStore from './LazySearchPageWithStore';
import LazyCategoryBrowsePage from './LazyCategoryBrowsePage';

const Router =
    process.env.REACT_APP_TARGET === 'server' ? StaticRouter : BrowserRouter;

export default function PageRoutes(props) {
    return (
        <Router location={props.request.path} context={{}}>
            <Switch>
                {/* /esi_cache is the request path when Varnish renders the page */}
                <Route
                    path="/esi_cache"
                    exact={true}
                    render={(routerProps) => (
                        <LazyFeedPageWithStore {...props} {...routerProps} />
                    )}
                />
                <Route
                    path="/"
                    exact={true}
                    render={(routerProps) => (
                        <LazyFeedPageWithStore {...props} {...routerProps} />
                    )}
                />
                <Route
                    path={`/d/:locationSlug/events/`}
                    render={(routerProps) => (
                        <LazyBrowsePageWithStore {...props} {...routerProps} />
                    )}
                />
                <Route
                    path={`/d/:locationSlug/:query`}
                    render={(routerProps) => {
                        if (
                            routerProps.match.params.query === 'browse2020' &&
                            props.user.isStaff
                        ) {
                            return (
                                <LazyCategoryBrowsePage
                                    {...props}
                                    {...routerProps}
                                />
                            );
                        }
                        return (
                            <LazySearchPageWithStore
                                {...props}
                                {...routerProps}
                            />
                        );
                    }}
                />
            </Switch>
        </Router>
    );
}
